/* eslint-disable @typescript-eslint/no-floating-promises */
import { Box } from 'pcln-design-system';
import React, { useContext, useState } from 'react';
import { submitChatMessages } from '../../submitChatMessages';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import UserInputBar from './UserInputBar';
import RecordingIndicator from '../../Voice/RecordingIndicator';
import pennyBroadcast, { BroadcastType } from '../../utils/pennyBroadcast';
import sanitizeInput from '../../utils/sanitizeInput';
import InputLimiter from '../InputLimiter';
import { Flex } from 'pcln-design-system';
import { PennyToolTip, useLoadingStateContext, useChatMessagesContext, useChatUIContext } from '../..';
/**
 * @internal ChatInputHandler input
 */
export const ChatInput = ({
  styles,
  isVoiceEnabled,
  startRecording,
  stopRecording,
  isAudioPlaybackEnabledRef,
  submitChatMessagesOptions,
  showToolTip
}) => {
  const {
    isDisablingInput,
    enableVoiceTooltip,
    submitChatMessagesPayload,
    setErrorMessage,
    logFirstMessageSubmitted
  } = useContext(ChatbotDataContext);
  const {
    isLoading
  } = useLoadingStateContext();
  const {
    setOpenErrorComponent
  } = useChatUIContext();
  const {
    chatMessages,
    setChatMessages
  } = useChatMessagesContext();
  const [inputLength, setInputLength] = useState(0);
  function handleLimiter(length) {
    setInputLength(length);
  }
  return React.createElement(Box, Object.assign({}, styles.inputStyle), React.createElement(React.Fragment, null, React.createElement(UserInputBar, {
    styles: styles,
    isDisablingInput: isDisablingInput,
    isLoading: isLoading,
    enableVoiceTooltip: enableVoiceTooltip,
    onTextSubmit: function (msg) {
      pennyBroadcast({
        type: BroadcastType.INTERRUPT_AUDIO_PLAYBACK,
        sender: 'ChatContent.startRecording()'
      });
      // Set the error message as empty if there is any
      setErrorMessage('');
      // cache the msg on local for reuse
      const chatMessage = {
        role: 'user',
        content: sanitizeInput(msg),
        date: new Date()
      };
      const promptMessage = {
        role: 'user',
        content: msg
      };
      const updatedChatMessages = [...chatMessages, chatMessage];
      // Update the message showing in the dialog
      setChatMessages([...chatMessages, chatMessage]);
      pennyBroadcast({
        type: BroadcastType.USER_SUBMITTED_TEXT,
        data: sanitizeInput(msg),
        sender: 'ChatContent.onTextSubmit()'
      });
      // Submit the user message
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      submitChatMessages(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: [promptMessage],
          includeSpeech: !!isVoiceEnabled && isAudioPlaybackEnabledRef.current
        }),
        setOpenErrorComponent,
        // Local state control
        chatMessages: updatedChatMessages
      }, submitChatMessagesOptions));
      // Log first user submitted message to chatbot
      if (chatMessages.length <= 1 && logFirstMessageSubmitted && typeof logFirstMessageSubmitted === 'function') {
        logFirstMessageSubmitted(chatMessage.content);
      }
    },
    onRecord: startRecording,
    onStopRecording: stopRecording,
    limiterCheck: handleLimiter
  }), React.createElement(RecordingIndicator, Object.assign({}, styles.recordingIndicatorStyle, {
    onClose: stopRecording
  }))), React.createElement(InputLimiter, {
    currentLength: inputLength
  }), showToolTip ? React.createElement(Flex, {
    justifyContent: 'center',
    alignItems: 'left',
    width: '100%',
    mb: 2
  }, React.createElement(PennyToolTip, {
    msgPosition: 'top',
    styles: styles
  })) : null);
};